<template>
    <el-dialog
            :visible="isVisible"
            @close="hide"
            :title="title"
            :destroy-on-close="true"
    >
        <loading v-if="!isInitialized"></loading>
        <email-quarantine-form
          v-if="isInitialized"
          v-bind="formData"
          @stored="onStored"
        ></email-quarantine-form>
    </el-dialog>
</template>

<script>
  import BaseDialogFormWrapper from '../../components/dialog-form-wrapper';
  import EmailQuarantineForm from '../../components/email-quarantine/form';
  import Loading from '../../components/loading';
  import eventBus from '../../event-bus';

  export default {
    extends: BaseDialogFormWrapper,

    components: {
      Loading,
      EmailQuarantineForm,
    },

    computed: {
      /**
       * @return {boolean}
       */
      modelExists() {
        return _.has(this.formData, 'model.id');
      },

      /**
       * @return {string}
       */
      title() {
        if (!this.isInitialized) {
          return 'Loading ...';
        } else if (this.modelExists) {
          return 'Approve Email Quarantine';
        }

        return 'Create Email Quarantine';
      },
    },

    methods: {
      /**
       * @param {string|undefined} message
       */
      onStored({message}) {
        _.isString(message) && this.$message.success(message);
        this.hide();
        eventBus.$emit('refresh-email-quarantine-table');
      },
    },

    created() {
      eventBus.$on('show-email-quarantine-form-dialog', this.show);
    },

    beforeDestroy() {
      eventBus.$off('show-email-quarantine-form-dialog', this.show);
    }
  }
</script>
